<!-- add-variant.component.html -->
<div class="variant-form-container">
  
  <!-- Loading Spinner -->
  <div *ngIf="isLoading" class="loading-overlay">
    <div class="loading-spinner">
      <div class="spinner"></div>
      <p class="loading-text">{{ loadingMessage }}</p>
    </div>
  </div>

  <div class="form-header">
    <h1>إضافة متغير جديد</h1>
    <p>أدخل بيانات المتغير الجديد في النموذج أدناه</p>
  </div>

  <form [formGroup]="variantForm" class="variant-form" [class.loading]="isLoading">
    
    <div class="form-section">
      <h2>المعلومات الأساسية</h2>
      
      <div class="form-row">
        <!-- الاسم -->
        <div class="form-group" [class.error]="isFieldInvalid('name')">
          <label for="name">اسم المتغير *</label>
          <input 
            type="text" 
            id="name"
            formControlName="name" 
            placeholder="أدخل اسم المتغير"
            [class.error]="isFieldInvalid('name')"
            [disabled]="isLoading"
          />
          <div class="error-message" *ngIf="isFieldInvalid('name')">
            ⚠️ {{ getFieldError('name') }}
          </div>
          <small class="form-text">اسم المتغير الذي سيظهر في القوائم المنسدلة</small>
        </div>

        <!-- الكود -->
        <div class="form-group" [class.error]="isFieldInvalid('code')">
          <label for="code">كود المتغير *</label>
          <input 
            type="text" 
            id="code"
            formControlName="code" 
            placeholder="أدخل كود المتغير"
            [class.error]="isFieldInvalid('code')"
            [disabled]="isLoading"
            (input)="validateCode()"
            style="text-transform: uppercase; font-family: monospace;"
          />
          <div class="error-message" *ngIf="isFieldInvalid('code')">
            ⚠️ {{ getFieldError('code') }}
          </div>
          <small class="form-text">
            كود مختصر للمتغير ( أرقام )
          </small>
        </div>
      </div>

      <div class="form-row">
        <!-- نوع القياس -->
        <div class="form-group" [class.error]="isFieldInvalid('measurement')">
          <label for="measurement">القياس *</label>
          <input 
            type="text" 
            id="measurement"
            formControlName="measurement" 
            placeholder="أدخل measurement"
            [class.error]="isFieldInvalid('measurement')"
            [disabled]="isLoading"
            style="text-transform: uppercase; font-family: monospace;"
          />
          <div class="error-message" *ngIf="isFieldInvalid('measurement')">
            ⚠️ {{ getFieldError('measurement') }}
          </div>
          <small class="form-text">ادخل القياس المناسب لهذا المتغير</small>
        </div>

        <!-- الحالة -->
        <div class="form-group status-group">
          <label for="status">حالة المتغير</label>
          <div class="status-toggle">
            <label class="toggle-switch">
              <input 
                type="checkbox" 
                id="status"
                formControlName="status"
                [disabled]="isLoading"
              />
              <span class="toggle-slider"></span>
            </label>
            <span class="status-text">
              {{ variantForm.get('status')?.value ? 'مفعل' : 'معطل' }}
            </span>
          </div>
          <small class="form-text">تفعيل أو تعطيل هذا المتغير</small>
        </div>
      </div>
    </div>

    <!-- أزرار التحكم -->
    <div class="form-actions">
      <button 
        type="button" 
        class="btn-cancel" 
        (click)="onCancel()"
        [disabled]="isLoading">
        إلغاء
      </button>
      
      <button 
        type="button" 
        class="btn-reset" 
        (click)="onReset()"
        [disabled]="isLoading">
        إعادة تعيين
      </button>
      
      <button 
        type="button" 
        class="btn-save" 
        (click)="onSubmit()"
        [disabled]="isLoading">
        <span *ngIf="!isLoading">إنشاء المتغير</span>
        <span *ngIf="isLoading">جاري الإنشاء...</span>
      </button>
    </div>

  </form>
</div>